import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import "../../styles/style.css";

class Link extends Component {
    render(){
        return (
            <span>
                <a href={this.props.url} className="svg">
                    <ReactSVG
                        src={this.props.svg}
                       evalScripts="always"
                        fallback={this.props.name}
                        svgStyle={this.props.darkMode ? {width:50, height:50, fill:"#f8f8f8"} : 
                                {width:50, height:50, fill:"#313131"}}
                    />
                </a>
            </span>
        );
    }
}

export default Link;
